import type { TaskTemplateCategory } from "./types";

export const MSP_SUPPORT_TEMPLATES: TaskTemplateCategory = {
  id: "support",
  name: "Technical Support",
  description: "Templates for technical support tasks",
  templates: [
    {
      id: "security-audit",
      name: "Perform Security Audit",
      description: "Conduct comprehensive security audit for client",
      title: "Security Audit: [Client Name]",
      description_text: `Perform comprehensive security audit including:

**Audit Areas:**
- [ ] Network security
- [ ] Endpoint protection
- [ ] User access controls
- [ ] Backup and recovery
- [ ] Compliance requirements

**Deliverables:**
- Security assessment report
- Remediation recommendations
- Implementation timeline`,
      tags: ["security", "audit", "compliance", "assessment"],
      priority: "high",
      status: "pending",
      category: "support",
    },
    {
      id: "backup-verification",
      name: "Verify Backup Systems",
      description: "Verify and test backup systems for client",
      title: "Backup Verification: [Client Name]",
      description_text: `Verify backup systems are working properly:

**Verification Steps:**
- [ ] Check backup status
- [ ] Test restore process
- [ ] Verify backup retention
- [ ] Document results
- [ ] Update backup documentation

**Systems to Check:**
- [List backup systems]`,
      tags: ["backup", "verification", "testing", "documentation"],
      priority: "medium",
      status: "pending",
      category: "support",
    },
  ],
};
